import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { format } from 'date-fns'
import { CalendarIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '../ui/button'
import { Calendar } from '../ui/calendar'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'

export default function CalendarField({ label, name, disabled }: { label?: string, name: string, disabled?: boolean }) {
    const form = useFormContext()
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => {
                const selectedDate = field.value ? new Date(field.value) : undefined
                return (
                    <FormItem className='flex flex-col'>
                        {label && <FormLabel>{label}</FormLabel>}
                        <Popover>
                            <PopoverTrigger asChild>
                                <FormControl>
                                    <Button
                                        variant={'outline'}
                                        className={cn(
                                            'w-[240px] pl-3 text-left font-normal',
                                            !selectedDate && 'text-muted-foreground'
                                        )}
                                        disabled={disabled}
                                    >
                                        {selectedDate ? (
                                            format(selectedDate, 'PPP')
                                        ) : (
                                            <span>Pick a date</span>
                                        )}
                                        <CalendarIcon className='ml-auto h-4 w-4 opacity-50' />
                                    </Button>
                                </FormControl>
                            </PopoverTrigger>
                            <PopoverContent className='w-auto p-0' align='start'>
                                <Calendar
                                    mode='single'
                                    selected={selectedDate}
                                    onSelect={(date) => field.onChange(date ? date.toISOString() : '')}
                                    captionLayout='dropdown'
                                    fromYear={2000}
                                    toYear={2030}
                                />
                            </PopoverContent>
                        </Popover>
                        <FormMessage />
                    </FormItem>
                )
            }}
        />
    )
}
